let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d8SO1")).then(() => parcelRequire('awnz4'));